import { Box, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor } from 'assets/styles/_palette';

export const DetailedStoryViewTab = styled(Box)<{ active: boolean }>(({ active }) => ({
	...flexMixin({}),
	padding: '8px 16px',
	width: 'fit-content',
	border: '1px solid #2867830F',
	borderRadius: '8px',
	lineHeight: '20px',
	letterSpacing: '0.15px',
	cursor: 'pointer',

	fontWeight: active ? '700' : '400',
	backgroundColor: active ? '#ECF3FF' : 'none',
	color: active ? '#4786FF' : regularTextColor,
}));
